/**
 * CardPlayButton Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import './styles.scss';

import * as classNames from 'classnames';
import { IconPlayerPause, IconPlayerPlay } from '../../../atoms/images/Icon';

interface IOwnProps {
  blurredImage?: string | null;
  className?: string;
  isPlaying?: boolean;
  onClick?(): void;
}

const classes = new BEM('card-play-button');

export default class CardPlayButton extends React.Component<IOwnProps, {}> {
  button = React.createRef<HTMLButtonElement>();

  onClick = () => {
    this.button.current!.blur();
    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    const {
      blurredImage,
      className,
      isPlaying,
    } = this.props;

    const PlayIcon = isPlaying ? IconPlayerPause : IconPlayerPlay;
    const classModifiers = {
      'is-playing': !!isPlaying,
    };
    const extraClasses = classNames(className, 'button');

    return (
      <button
        ref={this.button}
        onClick={this.onClick}
        {...classes('', classModifiers, extraClasses)}
      >
        {blurredImage &&
          <img {...classes('blurred-image')} src={blurredImage} alt=""/>
        }
        <PlayIcon />
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/buttons/CardPlayButton/index.tsx